/*
  Null Audio motion layer for the cable pages (see na-motion.css). Runs only when the head script
  has set html.na-motion (motion allowed). Adds .is-in as things scroll into view, splits section
  headings into words for the masked rise, counts the figures up, and lights dark sections with
  a pointer-following spotlight. Text is never changed for good: headings keep their words, and
  figures end on the exact text from the HTML.
*/
(function () {
  var html = document.documentElement;
  if (!html.classList.contains('na-motion')) return;
  window.naMotionReady = true;
  var scope = [].slice.call(document.querySelectorAll('[id^="shopify-section-"][id*="__na_"]'));
  if (!scope.length || !('IntersectionObserver' in window)) { html.classList.remove('na-motion'); return; }
  var all = function (sel) { var out = []; scope.forEach(function (s) { out.push.apply(out, s.querySelectorAll(sel)); }); return out; };

  // 6. headings: wrap each word (text-only headings); anything else just fades with the class
  all('h2, .na-cf__text h3').forEach(function (h) {
    if (h.closest('.nax__legend')) return;
    if (!h.children.length) {
      var words = h.textContent.trim().split(/\s+/);
      h.setAttribute('aria-label', h.textContent.trim());
      h.innerHTML = words.map(function (w, i) {
        return '<span class="na-m-w" aria-hidden="true" style="--d:' + i + '"><span>' + w.replace(/&/g, '&amp;').replace(/</g, '&lt;') + '</span></span>';
      }).join(' ');
    }
    h.classList.add('na-m-split');
  });

  // 5. figures: count up from zero to the number in the text, keeping prefix, decimals and unit
  function countUp(el) {
    var final = el.textContent;
    var m = final.match(/^(\D*?)(\d+(?:[.,]\d+)?)(.*)$/);
    // only figures with a spaced unit (35 g, 384 kHz): a grade like 5N would pass through 4N
    if (!m || /^[A-Za-z]/.test(m[3])) return;
    // a number glued to letters (QCC5181) or with no unit at all (a version like 5.4) stays put
    if (/[A-Za-z]$/.test(m[1]) || (!m[1].trim() && !m[3].trim())) return;
    // a year (Since 2008) stays put; 3,000+ is a thousands separator, not a decimal
    if (/^(19|20)\d\d$/.test(m[2])) return;
    var grouped = /^\d{1,3}(,\d{3})+$/.test(m[2]);
    var num = grouped ? +m[2].replace(/,/g, '') : parseFloat(m[2].replace(',', '.')), dec = grouped ? 0 : (m[2].split(/[.,]/)[1] || '').length;
    var t0 = performance.now(), dur = 1500 + Math.min(900, num * 2);
    el.setAttribute('aria-label', final);
    (function step(t) {
      var k = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - k, 4);
      el.textContent = k < 1 ? m[1] + (grouped ? Math.round(num * e).toLocaleString('en-US') : (num * e).toFixed(dec)) + m[3] : final;
      if (k < 1) requestAnimationFrame(step);
    })(t0);
  }

  // reveal on entering the viewport
  var proxyOf = new Map();
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      var el = proxyOf.get(e.target) || e.target;
      io.unobserve(e.target);
      el.classList.add('is-in');
      if (el.classList.contains('na-stats')) {
        el.querySelectorAll('li').forEach(function (li, i) { li.style.setProperty('--d', i); });
        el.querySelectorAll('.na-stats__value').forEach(countUp);
      }
    });
  }, { threshold: 0.18, rootMargin: '0px 0px -6% 0px' });
  all('h2.na-m-split, h3.na-m-split, .na-eyebrow, .na-cf__eyebrow, .na-cf__body, .na-ch__text > p, .na-box__list, .na-specs__groups, .na-app__points, .na-app__setup, .na-cmp__wrap, .na-cf__media, .na-box__media, .na-ch__media, .na-stats')
    .forEach(function (el) {
      // a frame clipped to nothing never intersects (Chrome applies the target's own clip-path),
      // so watch its parent and reveal the frame
      if (el.matches('.na-cf__media, .na-box__media, .na-ch__media') && el.parentElement) { proxyOf.set(el.parentElement, el); io.observe(el.parentElement); }
      else io.observe(el);
    });

  // 3. dark sections: grain, plus a spotlight that trails the pointer
  var lit = scope.filter(function (s) {
    if (s.offsetHeight < 240 || getComputedStyle(s).position === 'fixed') return false;
    var bg = getComputedStyle(s).backgroundColor.match(/\d+/g);
    return bg && bg.length >= 3 && (+bg[0] + +bg[1] + +bg[2]) < 120 && (bg[3] === undefined || +bg[3] > 0);
  });
  lit.forEach(function (s) { s.classList.add('na-m-lit'); });
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (!fine || !lit.length) return;
  var target = null, tx = 0, ty = 0, x = 0, y = 0, running = false;
  function loop() {
    if (!target) { running = false; return; }
    x += (tx - x) * 0.12; y += (ty - y) * 0.12;
    target.style.setProperty('--mx', x.toFixed(1) + 'px');
    target.style.setProperty('--my', y.toFixed(1) + 'px');
    if (Math.abs(tx - x) + Math.abs(ty - y) > 0.5) requestAnimationFrame(loop); else running = false;
  }
  document.addEventListener('pointermove', function (ev) {
    var s = ev.target.closest && ev.target.closest('.na-m-lit');
    if (s !== target) {
      if (target) target.style.setProperty('--lit', 0);
      target = s;
      if (!s) return;
      var r0 = s.getBoundingClientRect();
      x = ev.clientX - r0.left; y = ev.clientY - r0.top;
      s.style.setProperty('--lit', 1);
    }
    if (!s) return;
    var r = s.getBoundingClientRect();
    tx = ev.clientX - r.left; ty = ev.clientY - r.top;
    if (!running) { running = true; requestAnimationFrame(loop); }
  }, { passive: true });
  document.addEventListener('pointerleave', function () { if (target) target.style.setProperty('--lit', 0); target = null; });
})();
